import { CompletedModalNRFormComponent } from "./completed-modal-form/completed-modal-form.component";
import { ConfirmationModalNRFormComponent } from "./confirmation-modal-form/confirmation-modal-form.component";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { defineElement } from "@lordicon/element";
import lottie from 'lottie-web';
import { WarningModalNRFormComponent } from "./warning-modal-form/warning-modal-form.component";

@NgModule({
  declarations: [
    CompletedModalNRFormComponent,
    ConfirmationModalNRFormComponent,
    WarningModalNRFormComponent
  ],
  imports: [
  ],
  exports: [
    CompletedModalNRFormComponent,
    ConfirmationModalNRFormComponent,
    WarningModalNRFormComponent
  ],
  providers: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class FormsModalConfirmationModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
